/* eslint-disable max-lines */
import React from 'react';
import {connect} from 'react-redux';
import {reduxForm, formValueSelector, getFormValues, Field, change} from 'redux-form';
import {Card, Form, Grid, Input, Container, Icon, Popup, Button} from 'semantic-ui-react';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {paths} from '../../../../common/dictionaries/urls';
import {DISPATCH_ORDER_FORM} from '../../../../common/forms';
import {Actions} from '../../../../common/actions';
import {getDropdownOptions} from '../../../../common/util/dropdown';
import {dispatchOrderTypes} from '../../../../common/dictionaries/classification';
import {DropdownField} from '../../../../common/components/form';
import {requiredArray} from '../../../../common/components/form/common/fieldValidations';
import {ExportToExcelIconButton} from '../../../../common/util/exportToExcel/exportToExcelButtons';
import VehiclesModal from './vehiclesModal';
import DispatchOrderInfoCard from './dispatchOrderInfoCard';
import DispatchOrderExportFormat from './dispatchOrderExportFormat';
import DispatchOrderProcessButtons from './dispatchOrderProcessButtons';
import '../../dispatchOrdersStyles.scss';
import DispatchOrderVehiclesTable from './dispatchOrderVehiclesTable';
import {getColumns} from './dispatchOrderVehiclesTableColumns';

class DispatchOrderForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'columns': getColumns({
        'maxVehiclesSelected': this.maxVehiclesSelected.bind(this),
        'isOrderStatusNewOrIngressed': this.isOrderStatusNewOrIngressed.bind(this),
        'changeVehiclesArray': this.changeVehiclesArray.bind(this),
      }),
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.DispatchOrders, scopes.See) &&
    !hasAccessPermission(this.props.permissions, resources.DispatchOrders, scopes.Create) &&
    !hasAccessPermission(this.props.permissions, resources.DispatchOrders, scopes.Edit) &&
      !hasAccessPermission(this.props.permissions, resources.DispatchOrdersApproval, scopes.Approve)) {
      this.props.navigateTo(paths.AccessDenied);
      return;
    }
    this.props.fetchDealers('dealers-vehicles');
    this.props.fetchVehicleTypeCatalog();
    this.props.fetchMailGroupList();
    const {code} = this.props;
    if (code) {
      this.props.fetchDispatchOrder(code);
    }
  }

  componentWillUnmount() {
    this.props.clearDispatchOrder();
  }

  componentWillReceiveProps(newProps) {
    if (this.props.code !== newProps.code) {
      this.props.fetchDispatchOrder(newProps.code);
    }
  }

  getMaxValue = () => {
    const {formValues, vehiclesTypesList} = this.props;
    return formValues.type && vehiclesTypesList.length > 0 ?
      vehiclesTypesList.find((x) => x.code === formValues.type).rowsNumber :
      '';
  }

  getVehiclesSelected = () => {
    const {vehiclesArray} = this.props;
    return vehiclesArray.filter((x) => {
      if (x.action) {
        if (x.action !== 'DELETE') {
          return x;
        }
      } else {
        return x;
      }
    });
  }

  changeVehiclesArray = (selected, action) => {
    const {vehiclesArray} = this.props;
    const newValue = {...selected, 'action': action};
    const vehicleLoaded = vehiclesArray.find((veh) => veh.chassis === selected.chassis);
    if (vehicleLoaded) {
      const cVehLoaded = {...vehicleLoaded, 'action': action};
      const cVehLoadedIndex = vehiclesArray.indexOf(vehicleLoaded);
      const cVehArray = [...vehiclesArray];
      cVehArray.splice(cVehLoadedIndex, 1, cVehLoaded);
      this.props.change('vehiclesArray', cVehArray);
    } else {
      this.props.change('vehiclesArray', [...vehiclesArray, newValue]);
    }
  }

  disableFieldWhenVehSelected = () => {
    return this.getVehiclesSelected().length > 0 ? true : false;
  }

  maxVehiclesSelected = () => {
    const maxSelected = this.getVehiclesSelected().length;
    const maxValue = this.getMaxValue();
    return maxSelected === maxValue ?
      true :
      false;
  }

  isVehicleSelected = (vehicle) => {
    const {vehiclesArray} = this.props;
    const vehSelected = vehiclesArray.find((veh) => veh.chassis === vehicle.chassis);
    return vehSelected && vehSelected.action === 'INSERT' ?
      true : false;
  }

  sendToApproval = (value) => {
    this.props.change('sendOrder', value);
  }
  
  processOrder = () => {
    this.props.change('processOrder', true);
  }

  approveOrder = (value) => {
    this.props.change('approveOrder', value);
  }

  cancelOrder = () => {
    const {code} = this.props;
    const {status} = this.props.formValues;
    this.props.cancelDispatchOrder(code, status === 'I' ? 'D' : 'A').then(() => {
      this.props.navigateBack();
    });
  }

  isOrderStatusNewOrIngressed = () => {
    const {status} = this.props.formValues;
    return !status || status === 'I' ? true : false;
  }

  submitForm = () => {
    const {handleSubmit} = this.props;
    handleSubmit();
  }

  renderFormTitle() {
    const {code} = this.props;
    return code ? (
      <h2>ORDEN DE DESPACHO # {code}</h2>
    ) : (
      <h2>NUEVA ORDEN DE DESPACHO </h2>
    );
  }

  renderDealerField() {
    const {dealersList} = this.props;
    return (
      <React.Fragment>
        <Container textAlign='left' className='m-0'>
          <h4>Concesionario</h4>
        </Container>
        <Container>
          <Field name='dealerId' component={DropdownField} search fluid selection
            options={getDropdownOptions(dealersList, 'identification', 'name')}
            disabled={this.disableFieldWhenVehSelected()} validate={requiredArray} />
        </Container>
      </React.Fragment>
    );
  }

  renderInvoiceTypeField() {
    return (
      <React.Fragment>
        <Container textAlign='left' className='m-0'>
          <h4>Tipo de Facturación</h4>
        </Container>
        <Container>
          <Field name='anticipatedInvoice' component={DropdownField} search fluid selection
            options={getDropdownOptions(dispatchOrderTypes, 'id', 'description')}
            validate={requiredArray} disabled={this.disableFieldWhenVehSelected()} />
        </Container>
      </React.Fragment>
    );
  }

  renderStatusField() {
    const {formValues} = this.props;
    return (
      <React.Fragment>
        <Container textAlign='left' className='m-0'><h4>Estado de la orden</h4></Container>
        <Container textAlign='center'>
          <Input type='text' value={formValues.statusDescription.toUpperCase()} disabled fluid /></Container>
      </React.Fragment>
    );
  }

  renderVehiclesTypesField() {
    const {vehiclesTypesList} = this.props;
    return (
      <React.Fragment>
        <Container textAlign='left' className='m-0'>
          <h4>Tipo de Vehículo</h4>
        </Container>
        <Container>
          <Field name='type' component={DropdownField} search fluid selection
            options={getDropdownOptions(vehiclesTypesList.filter((x) => x.code !== 'O'), 'code', 'description')}
            validate={requiredArray} disabled={this.disableFieldWhenVehSelected()} />
        </Container>
      </React.Fragment>
    );
  }

  renderDocumentTypeField() {
    const {formValues, vehiclesTypesList} = this.props;
    const docTypeValue = formValues.type && vehiclesTypesList.length > 0 ?
      vehiclesTypesList.find((x) => x.code === formValues.type).documentTypeDescription : '';
    return (
      <React.Fragment>
        <Container textAlign='left' className='m-0'><h4>Tipo de Documento</h4></Container>
        <Container textAlign='center'><Input type='text' value={docTypeValue} disabled fluid /></Container>
      </React.Fragment>
    );
  }

  renderMaxValueField() {
    return (
      <React.Fragment>
        <Container textAlign='left' className='m-0'><h4>Cupo Máx.</h4></Container>
        <Container textAlign='center'><Input type='text' value={this.getMaxValue()} disabled fluid /></Container>
      </React.Fragment>
    );
  }

  renderVehSelectedCountField() {
    return (
      <React.Fragment>
        <Container textAlign='left' className='m-0'><h4>Cant. Veh.</h4></Container>
        <Container textAlign='center'>
          <Input type='text' value={this.getVehiclesSelected().length} disabled fluid />
        </Container>
      </React.Fragment>
    );
  }

  renderNotificationGroupField() {
    const {notificationGroups, formValues} = this.props;
    return (
      <React.Fragment>
        <Container textAlign='left' className='m-0'>
          <h4 className='flex'> Notificar A:
            {formValues.notificateTo &&
            <Popup trigger={<Icon name='info' className='info circle' color='blue' />}
              content={notificationGroups.find((x) => x.mailGroup === formValues.notificateTo).description} />}
          </h4>
        </Container>
        <Container>
          <Field name='notificateTo' component={DropdownField} search fluid selection
            options={getDropdownOptions(notificationGroups
              .filter((x) => {
                return x.mailGroup.includes('ORVE');
              }),
            'mailGroup', 'mailGroup')}
            validate={requiredArray} disabled={this.disableFieldWhenVehSelected()} />
        </Container>
      </React.Fragment>
    );
  }

  renderExportToExcelButton() {
    const {code} = this.props;
    if (code) {
      return (<ExportToExcelIconButton tableId='dispatchOrderExportTable'
        sheetName='order' fileName={`dispatchOrder_${this.props.code}`} />);
    }
  }

  render() {
    const {formValues, vehicleTypeDescription, load} = this.props;
    const formValuesToExport = {...formValues, 'typeDescription': vehicleTypeDescription};
    return (
      <Form className='provider-form' onSubmit={this.submitForm.bind(this)}>
        <Card raised fluid>
          <div className='title-bar' style={{'paddingBottom': '0'}}>
            <div className='title'>
              {this.renderFormTitle()}
              <div className='flex grow end'>
                <div className='flex' style={{'marginRight': '0.65em'}}>
                  {this.renderExportToExcelButton()}</div>
                <Popup content='Salir' inverted trigger={
                  <Button type='button' secondary size='big' compact
                    style={{'padding': '2px 0 8px 0'}} icon={
                      <Icon className='log out' size='big' color='red' link
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.navigateBack();
                        }}/>
                    }>
                  </Button>
                } />
              </div>
            </div>
          </div>
          <Grid padded>
            <Grid.Column computer={11} tablet={10} mobile={16} >
              <Grid>
                <Grid.Row>
                  <Grid.Column computer={8} tablet={16} mobile={16}>
                    {this.renderDealerField()}
                  </Grid.Column>
                  <Grid.Column computer={5} tablet={8} mobile={16}>
                    {this.renderInvoiceTypeField()}
                  </Grid.Column>
                  <Grid.Column computer={3} tablet={8} mobile={16}>
                    {this.renderStatusField()}
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column computer={6} tablet={11} mobile={16}>
                    {this.renderVehiclesTypesField()}
                  </Grid.Column>
                  <Grid.Column computer={4} tablet={5} mobile={16}>
                    {this.renderDocumentTypeField()}
                  </Grid.Column>
                  <Grid.Column computer={2} tablet={5} mobile={8}>
                    {this.renderMaxValueField()}
                  </Grid.Column>
                  <Grid.Column computer={2} tablet={5} mobile={8}>
                    {this.renderVehSelectedCountField()}
                  </Grid.Column>
                  <Grid.Column computer={2} tablet={5} mobile={8}>
                    {this.renderNotificationGroupField()}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
            <Grid.Column computer={5} tablet={6} mobile={16}>
              <DispatchOrderInfoCard addDate={formValues.addDate} addUser={formValues.addUser}
                updateDate={formValues.updateDate} updateUser={formValues.updateUser} />
              <DispatchOrderProcessButtons
                status={formValues.status}
                invoiceType={formValues.anticipatedInvoice}
                notificationGroup={formValues.notificateTo}
                vehiclesSelected={this.getVehiclesSelected().length}
                sendToApproval={this.sendToApproval.bind(this)}
                approveOrder={this.approveOrder.bind(this)}
                processOrder={this.processOrder.bind(this)}
                cancelOrder={this.cancelOrder.bind(this)} />
            </Grid.Column>
          </Grid>
        </Card>
        <DispatchOrderExportFormat tableId='dispatchOrderExportTable' values={formValuesToExport} />
        <Card fluid>
          <div className='flex middle'>
            <Icon name='car' size='huge' className='toyota-primary' />
            <h2>Vehículos</h2>
            <div className='flex grow middle end'>
              <VehiclesModal
                code={this.props.code}
                formValues={formValues}
                loading={load}
                changeVehiclesArray={this.changeVehiclesArray.bind(this)}
                checkVehSelected={this.isVehicleSelected.bind(this)}
                maxVehiclesSelected={this.maxVehiclesSelected.bind(this)} />
            </div>
          </div>
          <Field name='vehiclesArray' component={DispatchOrderVehiclesTable} columns={this.state.columns}
            data={formValues.vehiclesArray} />
        </Card>
      </Form>
    );
  }
}

export {DispatchOrderForm};

const form = reduxForm({
  'form': DISPATCH_ORDER_FORM.name,
})(DispatchOrderForm);

const mapStateToProps = (state, ownProps) => {
  const formSelector = formValueSelector(DISPATCH_ORDER_FORM.name);
  const formValues = getFormValues(DISPATCH_ORDER_FORM.name)(state);
  const vehiclesArray = formSelector(state, 'vehiclesArray');
  const vehTypeDescItem = state.vehiclesTypes.list.find((x) => x.code === formValues.type);
  const load = state.candidateVehicles.loading;
  return {
    'permissions': state.session.permissions,
    'dealersList': state.dealer.list,
    'vehiclesTypesList': state.vehiclesTypes.list,
    'loading': state.form.dispatchOrdersForm.loading,
    'load': load,
    'vehicleType': state.form.dispatchOrdersForm.values.type,
    'vehicleTypeDescription': vehTypeDescItem ? vehTypeDescItem.description : '',
    'notificationGroups': state.mailGroupList.list,
    vehiclesArray,
    formValues,
  };
};
  
const {
  fetchDispatchOrder,
  fetchDealers,
  fetchVehicleTypeCatalog,
  clearDispatchOrder,
  cancelDispatchOrder,
  navigateTo,
  navigateBack,
  fetchMailGroupList,
} = Actions;

export default connect(mapStateToProps, {
  fetchDispatchOrder,
  fetchDealers,
  fetchVehicleTypeCatalog,
  clearDispatchOrder,
  cancelDispatchOrder,
  navigateTo,
  navigateBack,
  fetchMailGroupList,
  change,
})(form);
